import React from 'react'
import { t } from 'ttag'

const ProfileSectionPromotedDocument = ({ section }) => {
  const fn =
    section.file && section.file.fileName ? section.file.fileName : section.fileId
  const generateButton = () => {
    if (section.includeButton) {
      return (
        <a href={section.file.fileUrl} download={fn} className="btn btn-full btn-gray">
          {section.buttonText ? section.buttonText : t`View Document`}
        </a>
      )
    }

    return null
  }
  const generateThumbnail = () => {
    if (section.includeThumbnail) {
      return (
        <div className="thumb-wrap">
          <a href={section.file.fileUrl} download={fn}>
            <img
              src={section.file.thumbUrl}
              alt={t`Thumbnail of document: ${section.file.fileName} `}
              className="img-responsive"
            />
          </a>
        </div>
      )
    }
  }

  if (section.file) {
    return (
      <div className="vidwrap">
        {generateThumbnail()}
        {generateButton()}
      </div>
    )
  }

  return null
}

export default ProfileSectionPromotedDocument
